/**
 * React toast — thin wrapper around Sonner for React surfaces.
 * Vanilla RealtimeService still uses @vanilla/ui/shared/ToastManager.js (Sonner + DOM fallback).
 */
import { toast } from 'sonner';

function desc(message, details) {
  const msg = String(message ?? '').trim();
  const det = String(details ?? '').trim();
  if (msg && det) return `${msg}\n${det}`;
  return msg || det || undefined;
}

export const toastManager = {
  show({ title = '', message = '', tone = 'info', duration = 4500, details = '' } = {}) {
    const primary = String(title || message || 'Notification').trim();
    const description = title ? desc(message, details) : (String(details ?? '').trim() || undefined);
    const opts = { description, duration: duration > 0 ? duration : Infinity };
    const fn = { success: toast.success, error: toast.error, warning: toast.warning, info: toast.info }[tone] || toast;
    fn(primary, opts);
  },
  success(title, message, details = '') { this.show({ title, message, details, tone: 'success' }); },
  info(title, message, details = '') { this.show({ title, message, details, tone: 'info' }); },
  warning(title, message, details = '') { this.show({ title, message, details, tone: 'warning' }); },
  error(title, message, details = '') { this.show({ title, message, details, tone: 'error', duration: 6500 }); },
  crmError(actionLabel, entityLabel, error, fallback = 'Please try again.') {
    this.error(`${actionLabel} failed`, `We could not ${actionLabel.toLowerCase()} the ${entityLabel}. ${fallback}`, error?.message || '');
  },
  crmSuccess(actionLabel, entityLabel, extra = '') {
    this.success(`${entityLabel} updated`, `${entityLabel} ${actionLabel.toLowerCase()} successfully.${extra ? ` ${extra}` : ''}`);
  },
};

// Back-compat default export for call sites that did `import { ToastManager }`
export const ToastManager = toastManager;
export default toastManager;
